import {Input, Select} from "antd";
import {ProductAttributeType, StyledAttributeItem} from "../tabs/ProductAttributes";
import React, {useContext} from "react";
import {CatalogContext} from "../../../../providers/CatalogProvider";

const {Option} = Select

type ProductAttributeCategoryProps = {
    category: ProductAttributeType
}

const ProductAttributeCategory = ({category}: ProductAttributeCategoryProps) => {
    const {categories, setCategories} = useContext(CatalogContext)

    const handleChangeCategory = (value: ProductAttributeType['parent_id']) => {
        setCategories(categories.map(item => ({
            ...item,
            parent_id: item.id === category.id ? value : item.parent_id,
            status: item.id === category.id ? 'changed' : item.status,
        })))
    }

    const handleChangeName: HandleChangeCategoryName = (name) => {
        setCategories(categories.map(item => ({
            ...item,
            name: item.id === category.id ? name : item.name,
            status: item.id === category.id ? 'changed' : item.status,
        })))
    }

    return (
        <StyledAttributeItem repeat={2}>
            <Input maxLength={40} placeholder="Name" value={category.name}
                   onChange={(e) => handleChangeName(e.target.value)}
            />

            <Select
                allowClear
                showSearch
                optionFilterProp="children"
                placeholder="Select Category"
                disabled={!!categories.find(item => Number(category.id) === Number(item.parent_id))}
                value={category.parent_id}
                onChange={handleChangeCategory}
            >
                {
                    categories.map(item => {
                        if (item.id === category.id || item.parent_id || item.newItem) return null

                        return <Option key={item.id} value={item.id}>
                            {item.name ?? "Empty Name"}
                        </Option>
                    })
                }
            </Select>
        </StyledAttributeItem>
    );
};

export default ProductAttributeCategory;

type HandleChangeCategoryName = (value: string) => void
